<template>
  <view class="tab-container">
    <view class="tab">
      <view
        class="tab-item"
        wx:for="{{refactorTabList}}"
        wx:key="{{item.value}}"
        wx:class="{{item.selected && 'selected'}}"
        bindtap="handleTabClick(item)"
      >
        {{ item.label }}
      </view>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  props: {
    tabKey: {
      type: Number,
      optionalTypes: [String],
      value: 1
    },
    tabList: {
      type: Array,
      value: []
    }
  },
  data: {},
  computed: {
    refactorTabList() {
      const _tabList = this.tabList.map((item) => {
        return {
          ...item,
          selected: item.value === this.tabKey
        }
      })
      return _tabList
    }
  },
  methods: {
    handleTabClick(item) {
      if (item.selected) return
      this.triggerEvent('settabkey', item.value)
    }
  }
})
</script>

<style lang="stylus" scoped>
.tab-container
  padding 0 12px
  background #fff
  margin-bottom 12px
  .tab
    width 100%
    padding 1.5px
    display flex
    font-family PingFangSC-Medium
    font-size 14px
    font-weight 500
    line-height 14px
    color #666666
    box-sizing border-box
    background #F2F6F9
    border-radius 6px
    &-item
      flex 1
      display flex
      justify-content center
      align-items center
      padding 8.5px 0
      border-radius 5px
      &.selected
        background #fff
      color #666
</style>

<script type="application/json">
{
  "usingComponents": {}
}
</script>